<template>
  <v-form v-model="formValid" ref="form" autocomplete="off">
    <div id="pripad-sumar">
      <div class="pripad-sumar-header">
        <v-container class="pa-0" :class="{ 'pt-7': !isMobile }">
          <h1 v-if="!isMobile" class="left mb-4 mt-20px">Sumár ponuky - {{ pripad.cislo }}</h1>
          <h2 v-else class="left mx-4 my-4">Sumár ponuky - {{ pripad.cislo }}</h2>
          <Status v-if="!isMobile" class="mt-8 ml-4" :state="pripad.idStavu" />
          <div class="nofloat">
            <template v-if="jeDealer">
              <text-group
                class="left"
                :class="{ 'mr-10': !isMobile, 'ml-4 mb-4': isMobile }"
                :gap="5"
                utext="Vytvorené dňa"
                :btext="datumVzniku"
              ></text-group>
              <text-group
                v-if="!isMobile"
                utext="Vytvoril"
                :gap="5"
                :btext="pripad.vytvoril"
              ></text-group>
            </template>
            <template v-else>
              <text-group
                class=""
                :class="{ 'ml-4 mb-4': isMobile }"
                :gap="5"
                utext="Vytvorené dňa"
                :btext="datumVzniku"
              ></text-group>
            </template>
          </div>
          <v-tabs
            class="sumar-tabs"
            :class="{ 'mt-23px': !isMobile, 'nofloat ml-4': isMobile }"
            v-model="tab"
            :key="mainTabStep"
            v-if="jePrihlaseny"
          >
            <v-tab>Predmety</v-tab>
            <v-tab :class="{ 'ml-40px': !isMobile, 'ml-6': isMobile }" v-if="showNajomcaTab">Žiadateľ</v-tab>
            <v-tab :class="{ 'ml-40px': !isMobile, 'ml-6': isMobile }" v-if="showDodatInfo"
              >Dodatočné informácie</v-tab
            >
          </v-tabs>
        </v-container>
      </div>
      <v-container class="pa-0">
        <v-tabs-items v-model="tab" v-show="predmetyLoaded">
          <v-tab-item>
            <div :class="{ 'd-flex flex-column': isMobile }">
              <v-btn
                v-if="getMenuItem('add_predmet').is_visible"
                :to="`/obchodny-pripad/${pripad.newId}?cislo_predmetu=${novyPredmet}&redirect=2`"
                class="btn-secondary"
                :class="{ 'my-24px': !isMobile, 'mx-4 mt-4': isMobile }"
                :disabled="
                  !getMenuItem('add_predmet').is_enabled === 0 ||
                  pripad == null ||
                  pripad.newId == null
                "
                >{{ getMenuItem('add_predmet').display_member }}</v-btn
              >
              <v-btn
                v-if="getMenuItem('dokumenty').is_visible"
                @click="redirectToUploadDokumentov(pripad.newId, '0', '', 'sumar-predmet')"
                :disabled="getMenuItem('dokumenty') === 0 || pripad == null || pripad.newId == null"
                class="btn-secondary"
                :class="{ 'my-24px ml-16px': !isMobile, 'mx-4 mt-4': isMobile }"
                >{{ getMenuItem('dokumenty').display_member }}</v-btn
              >
              <v-btn
                v-if="getMenuItem('tlacit_pripad').is_visible"
                :to="`/tlacdokumentov?newid=${pripad.newId}`"
                :disabled="
                  getMenuItem('tlacit_pripad') === 0 || pripad == null || pripad.newId == null
                "
                class="btn-secondary"
                :class="{ 'my-24px ml-16px': !isMobile, 'mx-4 mt-4': isMobile }"
                >{{ getMenuItem('tlacit_pripad').display_member }}</v-btn
              >
            </div>
            <div v-for="(item, index) in predmety" :key="index">
              <pripady-wizard-sumar-predmet
                :ref="'predmet' + index"
                @forceReload="reload"
                :class="{ 'mb-24px': !isMobile }"
                :predmet="item"
                :pravoNaAdresnuPonuku="pravoNaAdresnuPonuku"
                :show="showPredmet == index"
                @loaded="() => checkPredmetyLoaded()"
                @setShowPredmet="val => setShowPredmet(val, index)"
                @changeVariant="onChangeVariant()"
                @odoslatPonuku="varianty => odoslatPonuku(varianty)"
                :formaPodnikania="formaPodnikania"
                @reloadSpoludlznik="onReloadSpoludlznikDodatInfo"
                @odoslanieEmailuSpoludlznika="kontrolaPovinnostiSpoludlznika"
              />
            </div>
          </v-tab-item>
          <v-tab-item v-if="showNajomcaTab">
            <pripady-wizard-sumar-najomca
              ref="najomca"
              :menu="menu"
              :pravoNaAdresnuPonuku="pravoNaAdresnuPonuku"
              :formaPodnikania="formaPodnikania"
              @odoslatNaSchvalenie="odoslatNaSchvalenie"
            />
          </v-tab-item>
          <v-tab-item v-if="showDodatInfo" :eager="this.selectedVarianty.length > 0">
            <pripady-wizard-sumar-dodatocne-info
              ref="dodatInfo"
              :menu="menu"
              :pravoNaAdresnuPonuku="pravoNaAdresnuPonuku"
              @setCustomButton="setCustomButton"
              :formaPodnikania="formaPodnikania"
              :variant="selectedVarianty[0]"
              @sumarChangeTab="val => changeTab(val)"
              @reloadSpoludlznik="onReloadSpoludlznikPredmet"
              @setValid="
                val => setValid(val.value, val.property, val.message, val.showProgress, val.isError)
              "
            />
          </v-tab-item>
        </v-tabs-items>
      </v-container>
    </div>
    <kontrola-pred-schvalenim
      :cisloObchPripadu="pripad.cislo"
      :cisloPredmetu="pripad.cisloPredmetu"
      :formaPodnikania="formaPodnikania"
      :newId="pripad.newId"
      :isNeadresnaPonuka="isNeadresnaPonuka"
      ref="kontrolaPredSchvalenim"
      @sumarChangeTab="val => changeTab(val)"
      @openDodavatelInfoDialog="val => openDodavatelInfoDialog(val)"
      @updateZmenaDodavatela="val => updateZmenaDodavatela(val)"
      @setValid="
        val => setValid(val.value, val.property, val.message, val.showProgress, val.isError)
      "
    />
    <v-dialog
      :value="doplnenieUdajovDialog"
      overlay-color="#000"
      overlay-opacity="0.66"
      :persistent="true"
      width="500"
    >
      <v-card v-if="doplnenieUdajovDialog">
        <v-card-title class="d-flex justify-space-between">
          <span class="f16"> Odoslať na schválenie</span>
          <v-icon style="margin-left: auto" @click="doplnenieUdajovDialog = false"
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-card-text class="pb-3">
          <v-form ref="doplnujuceInfoDodavatelForm">
            <span class="gs100 f16">
              Doplňte, prosím, informácie o dodávateľovi financovaného predmetu.
            </span>
            <template v-for="(udaje, index) in doplnenieUdajov">
              <v-divider :key="'divider' + udaje.cislo_predmetu" class="my-3"></v-divider>
              <v-row :key="udaje.cislo_predmetu">
                <v-col cols="12">
                  <span class="white100 f18">{{ udaje.nazov }}</span>
                  <br />
                  <span class="gs100 f12">{{ udaje.poznamka }}</span>
                </v-col>
                <v-col cols="12" class="py-1">
                  <zakaznik-combo
                    :ref="'zakaznik-' + index"
                    :isKlient="!jeDealer"
                    @updateValue="val => (udaje.zakaznikUdaje = val)"
                    :rules="[rules.required]"
                  ></zakaznik-combo>
                </v-col>
                <v-col cols="12" class="py-1">
                  <text-box
                    v-if="!jeDealer"
                    :rules="[rules.required, rules.telefonneCisloRule]"
                    placeholder="+421"
                    label="Tel. číslo"
                    required
                    @input="val => (udaje.telCislo = val)"
                    textOnFocus="+421"
                    :removeCharacters="/[^+\d]/g"
                    :isPhoneNumber="true"
                    :cache="false"
                  ></text-box>
                </v-col>
              </v-row>
            </template>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="doplnUdajeZakaznika"
            class="btn-primary"
            variant="elevated"
            density="default"
          >
            Odoslať
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      :value="schvalenieDialogDealer"
      overlay-color="#000"
      overlay-opacity="0.66"
      :persistent="true"
      width="500"
    >
      <v-card>
        <v-card-title class="text-center">
          <div class="w100">
            <v-icon :size="32" class="success600 primary500"> done </v-icon>
          </div>
        </v-card-title>
        <v-card-text>
          <div class="white100 bold f16 text-center mb-15px">
            {{ 'Kontrola prebehla úspešne!' }}
          </div>
          <div class="white500 f16 text-center">Ponuka bola odoslaná na schválenie.</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="ml-5 bold gs100" text @click="schvalenieDialogDealer = false">
            Zavrieť
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>
<script>
import Status from '../basic/Status.vue';
import TextGroup from '../basic/TextGroup.vue';
import PripadyWizardSumarNajomca from './PripadyWizardSumarNajomca.vue';
import PripadyWizardSumarPredmet from './PripadyWizardSumarPredmet.vue';
import PripadyWizardSumarDodatocneInfo from './PripadyWizardSumarDodatocneInfo.vue';
import KontrolaPredSchvalenim from '../sumar/KontrolaPredSchvalenim.vue';
import { wizardMixin } from '../../mixins/wizardMixin.js';
import { pripadLinkMixin } from '../../mixins/pripadLinkMixin';
import { mapState, mapGetters } from 'vuex';
import protectedAxios from '../../auth/axios';
import { mapMutations } from 'vuex';
import { store } from '../../store.js';
import router from '../../router.js';
import ZakaznikCombo from '../basic/ZakaznikCombo.vue';
import TextBox from '../basic/TextBox.vue';
const { getNormalizedSumarRoute } = require('../../utils/sumarFlow');

export default {
  mixins: [wizardMixin, pripadLinkMixin],
  props: {
    //toto je hack. Stepper slider sa nevyrenderuje pretoze v case ked sa vyrenderuje formular obrazovka wizarda, sumar este nie je pouzivatelovi zobrazeny.
    //komponent v-tabs prinutime rerenderovat pomocou key-change. MainTabStep sa zmeni po kliknuti na tab a preto ked klikneme na Sumar, formular sa
    //zobrazu a slider sa uz spravne zobrazi
    mainTabStep: Number,
  },
  components: {
    Status,
    TextGroup,
    PripadyWizardSumarNajomca,
    PripadyWizardSumarPredmet,
    PripadyWizardSumarDodatocneInfo,
    KontrolaPredSchvalenim,
    ZakaznikCombo,
    TextBox,
  },
  data: () => ({
    defaultMessage: {
      text: '',
      isError: false,
    },
    stavPripadu: null,
    test: 0,
    tab: 0,
    predmety: [],
    novyPredmet: 1,
    loadingMenu: true,
    menu: [],
    showPredmet: 0,
    formaPodnikania: null,
    doplnenieUdajovDialog: false,
    doplnenieUdajov: [],
    selectedVarianty: [],
    predmetyLoaded: false,
    rules: {
      telefonneCisloRule(v) {
        if (!v) return true;
        if (!/^\+/.test(v)) return 'Telefónne číslo musí začínať znakom +';
        if (v.length < 10) return 'Nie je vyplnené telefónne číslo';
        if (!/^(\+)[0-9]*$/.exec(v)) return 'Telefónne číslo može obsahovať iba číslice';
        return true;
      },
      required: value => {
        return !!value || value === 0 || 'Povinné pole';
      },
      // TODO pre ico max 20 znakov a pre obch_meno max 100 znakov
      // TODO porozmyslat nad globalnym zadanim max znakov pre inputy
    },
    schvalenieDialogDealer: false,
    firstOdoslanieNaSchvalenie: true,
    isNeadresnaPonuka: true,
    neadresnaPonukaLoaded: false,
  }),
  watch: {
    currentControl(val) {
      if (val === this.controlName) {
        //console.log('test', this.controlName);

        this.setCustomButtons();
      }
    },
    menu(val) {
      if (val && this.currentControl === this.controlName) {
        this.setCustomButtons();
      }
    },
    loadingMenu() {
      this.checkPredmetyLoaded();
    },
    predmetyLoaded(val){
      this.$nextTick(async () =>{
        //TODO toto sa mozno nezavola ked sa zmeni this.loadingMenu na true a naspet na false, vtedy sa znova nacitaju predmety 
        if(val){
          if (!this.neadresnaPonukaLoaded) {
            await this.getNeadresnaPonuka();
          }
          let normalizeSumarRoute = false;
          const routeKontrola = this.$route.query.kontrola;
          this.loadingSelectedVarianty();
          switch(this.$route.name){
            case "pripadSumarNajomca": 
                this.changeTab(this.isNeadresnaPonuka ? 0 : 1);
                normalizeSumarRoute = true;
            break;
            case "pripadSumarDodatInfo": 
                if (this.isNeadresnaPonuka) {
                  this.changeTab(0);
                } else {
                  this.selectedVarianty.length > 0 ? this.changeTab(2) : this.changeTab(0);
                }
                normalizeSumarRoute = true;
            break;
            default:
              this.changeTab(0);
          }
          if (normalizeSumarRoute) {
            try {
              await this.$router.replace(getNormalizedSumarRoute(this.$route));
            } catch (e) {
              console.error('Nepodarilo sa zosynchronizovať route sumáru.', e);
              this.setLoadingDialog();
              return;
            }

            if (this.$route.name !== 'pripadSumar') {
              this.setLoadingDialog();
              return;
            }
          }
          this.setLoadingDialog();
          if (
            (this.odoslatNaSchvalenieRequest.newId == this.pripad.newId ||
              routeKontrola) &&
            this.selectedVarianty.length > 0
          ) {
            this.setOdoslatNaSchvalenieRequest(null);
            this.odoslatNaSchvalenie(true, normalizeSumarRoute);
          }
        }
      });
    },
    tab(val) {
      if (val == 1) {
        this.setExtSuhlasyDisplayed(true);
      }
    },
  },
  computed: {
    ...mapState(['pripad']),
    ...mapGetters([
      'pravoNaAdresnuPonuku',
      'jePrihlaseny',
      'jeDealer',
      'isMobile',
      'odoslatNaSchvalenieRequest',
    ]),
    datumVzniku() {
      return this.pripad.datumVzniku?.formatDate();
      },
    showNajomcaTab() {
      return !this.isNeadresnaPonuka;
    },
    showDodatInfo() {
      if (this.isNeadresnaPonuka || !this.pravoNaAdresnuPonuku) {
        return false;
      }

      let show = true;
      if (this.jeDealer) {
        if (
          this.formaPodnikania == null ||
          this.formaPodnikania.pkId == 1 ||
          this.formaPodnikania.pkId == 2
        ) {
          show = false;
        }
      }

      return this.selectedVarianty.length > 0 && show;
    },
  },
  methods: {
    ...mapMutations([
      'setHandleExit',
      'setJeRozpracovany',
      'setPripad',
      'setCisloPredmetu',
      'setLoadingDialog',
      'openDialog',
      'closeDialog',
      'setOdoslatNaSchvalenieRequest',
    ]), 
    ...mapMutations('variables', ['setExtSuhlasyDisplayed']),
    async reload() {
      this.setLoadingDialog({
        open: true,
        btext: 'Prebieha načítavanie sumáru',
        utext: 'Prosím počkajte',
      });
      this.predmety = [];
      this.predmetyLoaded = false;
      this.selectedVarianty = [];
      this.loadingMenu = true;
      this.setJeRozpracovany(false);
      this.setHandleExit(false);
      this.getNeadresnaPonuka();
      await protectedAxios.get(`/pripady/${this.pripad.newId}`).then(res => {
        console.log('set Pripad');
        if (res.data)
          this.setPripad({
            jeRozpracovany: this.pripad.jeRozpracovany,
            handleExit: this.pripad.handleExit,
            cislo: this.pripad.cislo,
            newId: res.data.new_id,
            cisloPredmetu: this.pripad.cisloPredmetu,
            canOpenPredmet: true,
            idZastupcu: this.pripad.idZastupcu,
            cisloPlz: this.pripad.cisloPlz,
            predmetZamknuty: this.pripad.predmetZamknuty,
            idStavu: res.data.id_stavu,
            datumVzniku: res.data.datum_vzniku,
            vytvoril: res.data.vystavil_login,
          });
      });

      await protectedAxios
        .get(`/sumar/predmety?newId=${this.pripad.newId}`, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(res => {
          this.predmety = res?.data ?? [];
          this.novyPredmet = Math.max(...this.predmety.map(o => o.cislo_predmetu), 1) + 1;
          this.showPredmet = this.getDefaultPredmetIndex(this.predmety);
          this.syncSelectedPredmet(this.showPredmet);
        })
        .catch(e => {
          console.error(e);
        });
      this.getMenu();
    },
    //beforeStep vola PripadyWizard.vue po validacii formulara. Musi vratit promise !!!
    beforeStep() {
      return Promise.resolve(true);
    },
    schvalovanieLoading(open) {
      this.setLoadingDialog({
        open: open,
        btext: 'Prebieha proces schvalovania...',
        utext: 'Proces môže trvať aj niekoľko sekúnd',
      });
    },
    async closeWizard() {
      await protectedAxios.get('/sumar/ulozit-zavriet-redirect').then(res => {
        if (res.data) {
          if (res.data.startsWith('/')) {
            return router.push(res.data);
          } else {
            window.location.href = res.data;
          }
        }
      });
    },

    async openNewWizard() {
      if (this.jePrihlaseny && this.jeDealer == false) {
        window.onbeforeunload = null;

        await protectedAxios
          .get(`/login/action-redirect`, {
            headers: {
              'Content-Type': 'application/json',
            },
            params: {
              step: -1, //novy obch pripad s naplnenim info o profile
            },
          })
          .then(res => {
            if (res.data != null) {
              window.open(res.data, '_self');
            }
          })
          .catch(e => {
            console.error(e);
          });
      } else {
        router.push('/obchodny-pripad');
      }
    },
    getMenu() {
      protectedAxios
        .get(`/pripady/${this.pripad.newId}/menu/1`, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(res => {
          this.menu = res.data;
          this.loadingMenu = false;
        });
    },
    getMenuItem(valueMember) {
      let menufiltered = this.menu.filter(m => m.value_member === valueMember);
      if (menufiltered.length > 0) {
        return menufiltered[0];
      }
      return {};
    },
    getFormaPodnikania() {
      return protectedAxios.get(`sumar/formaPodnikania?newId=${this.pripad.newId}`).then(res => {
        this.formaPodnikania = res.data;
      });
    },
    setShowPredmet(show, index) {
      if (show) {
        this.showPredmet = index;
        this.syncSelectedPredmet(this.showPredmet);
        return this.showPredmet;
      }
      return (this.showPredmet = -1);
    },
    getDefaultPredmetIndex(predmety) {
      if (!Array.isArray(predmety) || predmety.length === 0) {
        return -1;
      }

      let selectedIndex = 0;
      let selectedTimestamp = Number.NEGATIVE_INFINITY;

      for (let i = 0; i < predmety.length; i++) {
        const predmet = predmety[i];
        const timestamp = predmet?.modifikovane ? Date.parse(predmet.modifikovane) : Number.NaN;

        if (Number.isNaN(timestamp)) {
          continue;
        }

        if (timestamp > selectedTimestamp) {
          selectedTimestamp = timestamp;
          selectedIndex = i;
        }
      }

      return selectedIndex;
    },
    syncSelectedPredmet(index) {
      const selectedPredmet = index >= 0 ? this.predmety[index] : null;
      this.setCisloPredmetu(selectedPredmet?.cislo_predmetu ?? null);
    },
    setCustomButtons() {
      this.setCustomButton(
        false,
        this.getMenuItem('novy_pripad').is_enabled,
        this.getMenuItem('novy_pripad').display_member,
        this.openNewWizard
      );

      this.setCustomButtonSecondary(
        false,
        this.getMenuItem('ulozit_zavriet').display_member,
        this.closeWizard
      );

      if (this.getMenuItem('novy_pripad').is_visible) {
        if (this.getMenuItem('novy_pripad').is_primary) {
          this.setCustomButton(
            true,
            this.getMenuItem('novy_pripad').is_enabled,
            this.getMenuItem('novy_pripad').display_member,
            this.openNewWizard
          );
        } else {
          this.setCustomButtonSecondary(
            true,
            this.getMenuItem('novy_pripad').display_member,
            this.openNewWizard
          );
        }
      }
      if (this.getMenuItem('odoslat_na_schvalenie').is_visible) {
        if (this.getMenuItem('odoslat_na_schvalenie').is_primary) {
          this.setCustomButton(
            true,
            this.getMenuItem('odoslat_na_schvalenie').is_enabled,
            this.getMenuItem('odoslat_na_schvalenie').display_member,
            () => {
              this.loadingSelectedVarianty();
              this.odoslatNaSchvalenieDialog();
            }
          );
        } else {
          this.setCustomButtonSecondary(
            true,
            this.getMenuItem('odoslat_na_schvalenie').display_member,
            () => {
              this.loadingSelectedVarianty();
              this.odoslatNaSchvalenieDialog();
            }
          );
        }
      }

      if (this.getMenuItem('ulozit_zavriet').is_visible) {
        if (this.getMenuItem('ulozit_zavriet').is_primary) {
          this.setCustomButton(
            true,
            this.getMenuItem('ulozit_zavriet').is_enabled,
            this.getMenuItem('ulozit_zavriet').display_member,
            this.closeWizard
          );
        } else {
          this.setCustomButtonSecondary(
            true,
            this.getMenuItem('ulozit_zavriet').display_member,
            this.closeWizard
          );
        }
      }
      if (this.getMenuItem('odoslat_email').is_visible) {
        if (this.getMenuItem('odoslat_email').is_primary) {
          this.setCustomButton(
            true,
            this.getMenuItem('odoslat_email').is_enabled,
            this.getMenuItem('odoslat_email').display_member,
            null
          );
        } else {
          this.setCustomButtonSecondary(
            true,
            this.getMenuItem('odoslat_email').display_member,
            null
          );
        }
      }
    },
    onChangeVariant() {
      this.setValid(true, 'spustenieOdosielaniaNaSchvalenie', '', false, true);
      this.loadingSelectedVarianty();
      if (this.selectedVarianty && this.getMenuItem('odoslat_na_schvalenie').is_visible) {
        this.setCustomButton(
          true,
          true,
          this.getMenuItem('odoslat_na_schvalenie').display_member,
          this.odoslatNaSchvalenieDialog
        );
      }
    },
    loadingSelectedVarianty() {
      this.selectedVarianty = [];
      for (let i = 0; i < this.predmety.length; i++) {
        if (this.$refs['predmet' + i][0]?.selectedVariant != null) {
          this.selectedVarianty.push({
            ...this.$refs['predmet' + i][0]?.selectedVariant,
            cisloPredmetu: this.predmety[i].cislo_predmetu,
          });
        }
      }
    },
    kontrolaPouzivatelaPredOdoslanimNaSchvalenie() {
      if (!this.jePrihlaseny) {
        let _dialog = {
          persistent: true,
          header: `<span class="f16"> Odoslať ponuku na schválenie </span>`,
          closeIcon: {
            value: true,
          },
          text: '',
          primaryBtn: {
            text: null,
            func: null,
          },
          secondaryBtn: {
            text: null,
            func: null,
          },
        };
        _dialog.text = `<span class="white100 f16"> Táto funkcia je prístupná len pre prihlásených klientov. </span>
            <br/>
            <span class="gs100 f16">
              Vytvorte si u nás účet a okamžite viete poslať ponuku financovania na schválenie. Zaslať žiadosť o financovanie pre právnickú osobu môže len štatutár firmy alebo prokúra.
            </span>
            <br />
            <br />
            <span class="gs100 f16">
              Na vytvorenie účtu je potrebné overenie tvárovou biometriou.
            </span>
            <br />
            <span class="gs100 f16"> Vyhraďte si preto na tento proces dostatok času. </span>
            <br />
            <br />
            <span class="gs100 f16">
              Ak už ste klientom a máte prístup do Klientskej zóny, prihláste sa.
            </span>`;
        _dialog.primaryBtn = {
          text: 'Vytvoriť účet',
          func: async () => {
            await protectedAxios.get('/login/create-account-link').then(res => {
              if (res.data.redirectUrl) {
                let query = '?ref=eklient';
                let step = localStorage.getItem('curr_new_obc_step');

                if (this.pripad.newId) {
                  query += '&obcNum=' + this.pripad.newId;
                }
                if (step) {
                  query += '&step=' + step;
                }

                window.onbeforeunload = null;
                window.location.href = res.data.redirectUrl + query;
              }
            });
          },
        };
        _dialog.secondaryBtn = {
          text: 'Prihlásiť sa',
          func: async () => {
            window.onbeforeunload = null;
            let step = localStorage.getItem('curr_new_obc_step');

            await store.dispatch('auth/authenticate', {
              customQueryParams: {
                ref: 'eklient',
                step: step,
                obcNum: this.pripad.newId,
              },
            });
          },
        };
        this.openDialog(_dialog);
      } else {
        this.odoslatNaSchvalenie();
      }
    },
    odoslatNaSchvalenie(ignoreDodatInfoDirty = false, kontrolaPoPresmerovani = false) {
      this.firstOdoslanieNaSchvalenie = false;
      this.resetCache().then(async _ => {
        if (this.$refs.najomca?.osobUdajeExtChanged) {
          await this.$refs.najomca.setSuhlasOsobUdajeExt();
        }
        if (this.$refs.najomca?.udajeOZmluveExtChanged) {
          await this.$refs.najomca.setUdajeOZmluveExt();
        }
        if (this.$refs?.dodatInfo?.dirty && !ignoreDodatInfoDirty) {
          if (await this.$refs.dodatInfo.saveData()) {
            return Promise.reject();
          }
        }
        if (this.$refs?.najomca?.showSuhlasySensitiveBusiness) {
          this.schvalovanieLoading(true);
          const canContinue = await this.$refs.najomca?.processSuhlasySensitiveBusiness();
          if (!canContinue) {
            this.schvalovanieLoading(false);
            return;
          }
        }
        this.schvalovanieLoading(true);
        this.$refs.kontrolaPredSchvalenim
          .execute(this.selectedVarianty, kontrolaPoPresmerovani)
          .then(async res => {
            if (res == true) {
              if (this.kontrolaPovinnostiSpoludlznika()) {
                return await this.schvalovanie(
                  this.selectedVarianty.map(variant => ({
                    CisloPlz: variant.cislo_plz,
                    IdVariantu: variant.pkid,
                  }))
                );
              } else {
                this.setLoadingDialog();
              }
            }
          })
          .catch(e => {
            this.setLoadingDialog();
          });
      });
    },
    async schvalovanie(varianty) {
      return await protectedAxios
        .post('sumar/schvalovanie-filip', {
          newId: this.pripad.newId,
          varianty: varianty,
        })
        .then(res => {
          let open = true;
          let _dialog = {
            persistent: true,
            header: `<span class="f16"> Odoslať na schválenie </span>`,
            closeIcon: {
              value: true,
            },
            text: ``,
          };
          if (res.data.length > 0) {
            if (this.formaPodnikania.pkId == 3) {
              _dialog.text = `<span class="gs100 f16">
                Ponuka bude odoslaná na schválenie po úspešnom prihlásení spolužiadateľa.
              </span>`;
            } else {
              _dialog.text = `<span class="gs100 f16">
                Ponuka bude odoslaná na schválenie po úspešnom prihlásení štatutárov. Jeho priebeh si môžete pozrieť v záložke Dodatočné informácie.
              </span>`;
            }
          } else {
            if (this.jeDealer) open = false;
            _dialog.text = `<span class="gs100 f16">
              Ponuka bola úspešne odoslaná na schválenie. O výsledku schvaľovacieho procesu vás
              informujeme e-mailom.
            </span>`;
            _dialog.timer = 5000;
          }
          if (open) {
            this.openDialog(_dialog);
          } else {
            this.schvalenieDialogDealer = true;
          }
          this.setExtSuhlasyDisplayed(false);
          this.setOdoslatNaSchvalenieRequest(null);
          if (this.tab != 0) {
            this.changeTab(0);
          }
        })
        .catch(e => {
          console.error(e);
        })
        .finally(() => {
          this.reload();
        });
    },
    async odoslatPonuku(variant) {
      this.schvalovanieLoading(true);
      let varianty = [];
      varianty.push({
        CisloPlz: variant.cislo_plz,
        IdVariantu: variant.pkid,
      });
      return await this.schvalovanie(varianty).finally(() => {
        this.setLoadingDialog();
        this.getMenu();
      });
    },
    async odoslatNaSchvalenieDialog() {
      if (this.selectedVarianty.length == 0) {
        this.setValid(
          false,
          'spustenieOdosielaniaNaSchvalenie',
          'Pre odoslanie na schválenie je potrebné vybrať jednu z ponúk',
          false,
          true
        );
        return;
      }
      if (this.$refs.najomca?.osobUdajeExtChanged) {
        await this.$refs.najomca.setSuhlasOsobUdajeExt();
      }
      if (this.$refs.najomca?.udajeOZmluveExtChanged) {
        await this.$refs.najomca.setSuhlasUdajeOZmluveExt();
      }
      if (this.$refs.dodatInfo?.dirty) {
        if (await this.$refs.dodatInfo.saveData()) {
          return;
        }
      }
      if (!this.jeDealer && this.firstOdoslanieNaSchvalenie) {
        let _dialog = {
          persistent: true,
          header: `<span class="f16"> Odoslať ponuku na schválenie </span>`,
          closeIcon: {
            value: true,
          },
          text: '',
          primaryBtn: {
            text: null,
            func: null,
          },
          secondaryBtn: {
            text: null,
            func: null,
          },
        };
        _dialog.text = `<span class="gs100 f16">
            Uistite sa, že všetky zadané údaje sú správne. Kúpna cena a cenníková cena ovplyvňuje
            výšku splátok. Tieto údaje si môžete skontrolovať v Sumáre ponuky v časti <b>Informácie o
            predmete</b>.
          </span>`;
        _dialog.primaryBtn = {
          text: 'Odoslať na schválenie',
          func: () => {
            this.closeDialog();
            this.kontrolaPouzivatelaPredOdoslanimNaSchvalenie();
          },
        };
        _dialog.secondaryBtn = {
          text: 'Skontrolovať údaje',
          func: () => {
            this.changeTab(0);
            this.closeDialog();
          },
        };
        this.openDialog(_dialog);
      } else {
        this.kontrolaPouzivatelaPredOdoslanimNaSchvalenie();
      }
    },
    checkPredmetyLoaded() {
      let loaded = true;
      if (this.predmety.length == 0 || this.loadingMenu) {
        return false;
      }
      for (let i = 0; i < this.predmety.length; i++) {
        if (this.$refs['predmet' + i] == null || !this.$refs['predmet' + i][0].isLoaded) {
          loaded = false;
          break;
        }
      }
      this.predmetyLoaded = loaded;
    },
    openDodavatelInfoDialog(val) {
      this.doplnenieUdajov = [];
      if (val.length > 0) {
        for (let i = 0; i < this.predmety.length; i++) {
          if (val.includes(this.predmety[i].cislo_predmetu)) {
            let vin = this.predmety[i].je_auto
              ? this.predmety[i].vyrobne_cislo
              : this.predmety[i].tech_vyrobne_cislo;
            let selectedVariant = this.$refs['predmet' + i][0].selectedVariant;
            this.doplnenieUdajov.push({
              nazov: this.predmety[i].nazov_predmetu,
              poznamka:
                vin != null
                  ? (this.predmety[i].je_auto ? 'VIN - ' : 'Výrobné číslo - ') + vin
                  : null,
              zakaznikUdaje: null, //ico a obch meno
              telCislo: null,
              cislo_predmetu: this.predmety[i].cislo_predmetu,
              cisloPlz: selectedVariant.cislo_plz,
            });
          }
        }
        this.doplnenieUdajovDialog = true;
      }
    },
    async doplnUdajeZakaznika() {
      let isZakaznikComboValid = true;
      this.doplnenieUdajov.forEach((_, index) => {
        const isComboValid = this.$refs['zakaznik-' + index][0].$refs.form.validate();
        if (!isComboValid) {
          isZakaznikComboValid = false;
        }
      });
      if (!this.$refs.doplnujuceInfoDodavatelForm.validate() || !isZakaznikComboValid) return;

      await protectedAxios
        .post('sumar/updatePredmetDodavatel', {
          NewId: this.pripad.newId,
          Predmety: this.doplnenieUdajov.map(predmet => ({
            CisloPredmetu: predmet.cislo_predmetu,
            CisloPlz: predmet.cisloPlz,
            Ico: predmet.zakaznikUdaje.ico,
            IdZakaznika: predmet.zakaznikUdaje.id_zakaznika
              ? predmet.zakaznikUdaje.id_zakaznika
              : -1,
            ObchodneMeno: predmet.zakaznikUdaje.snazov,
            Telefon: predmet.telCislo,
          })),
        })
        .then(res => {
          this.doplnenieUdajovDialog = false;
          this.doplnenieUdajov = [];
          this.odoslatNaSchvalenie();
        })
        .catch(e => {
          console.log(e);
          this.doplnenieUdajov = [];
          this.doplnenieUdajovDialog = false;
        });
    },
    async updateZmenaDodavatela(val) {
      this.schvalovanieLoading(true);
      let zmenaDodavatela = [];
      if (val.length > 0) {
        for (let i = 0; i < this.predmety.length; i++) {
          if (val.includes(this.predmety[i].cislo_predmetu)) {
            let varianty = this.$refs['predmet' + i][0].varianty;
            for (let v = 0; v < varianty.length; v++) {
              if (!zmenaDodavatela.some(variant => variant.CisloPlz == varianty[v].cislo_plz)) {
                zmenaDodavatela.push({
                  CisloPredmetu: this.predmety[i].cislo_predmetu,
                  CisloPlz: varianty[v].cislo_plz,
                });
              }
            }
          }
        }
        await protectedAxios
          .post('sumar/updateZmenaDodavatela', {
            NewId: this.pripad.newId,
            Varianty: zmenaDodavatela,
          })
          .then(async res => {
            this.setOdoslatNaSchvalenieRequest({
              cisloObchPripadu: this.pripad.cislo,
              cisloPredmetu: this.pripad.cisloPredmetu,
              varianty: null,
              newId: this.pripad.newId,
            });
            await this.reload();
          })
          .catch(e => {
            console.log(e);
            this.setLoadingDialog();
          });
      }
    },
    onReloadSpoludlznikPredmet() {
      for (let i = 0; i < this.predmety.length; i++) {
        this.$refs['predmet' + i][0]?.reloadSpoludlznik();
      }
    },
    onReloadSpoludlznikDodatInfo() {
      this.$refs['dodatInfo']?.reloadSpoludlznik();
      for (let i = 0; i < this.predmety.length; i++) {
        if (i != this.showPredmet) {
          this.$refs['predmet' + i][0]?.reloadSpoludlznik();
        }
      }
    },
    changeTab(val) {
      console.log(val);
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      }); 
      if (this.isNeadresnaPonuka && (val === 1 || val === 2)) {
        this.tab = 0;
        return;
      }
      if (val == 2) {
        this.$refs.dodatInfo.dirty = true;
      }
      this.tab = val;
    },
    kontrolaPovinnostiSpoludlznika() {
      for (let i = 0; i < this.predmety.length; i++) {
        if (!this.$refs['predmet' + i][0].kontrolaPovinnostiSpoludlznika()) {
          if (this.tab != 0) {
            this.changeTab(0);
          }
          this.showPredmet = i;
          this.$nextTick(() => {
            const firstInvalidField = this.$el.querySelector('.v-input.error--text');
            this.$vuetify.goTo(firstInvalidField, {
              duration: 500,
              easing: 'easeInOutCubic',
              offset: 150,
            });
            this.setValid(
              false,
              'emailSpoludlznika',
              'Prosím vyplňte všetky povinné polia!',
              false,
              true
            );
          });
          return false;
        }
      }
      this.setValid(true, 'emailSpoludlznika', '', false, true);
      return true;
    },
    async getNeadresnaPonuka() {
      this.neadresnaPonukaLoaded = false;

      try {
        const res = await protectedAxios.get(`/sumar/neadresnaPonuka?newId=${this.pripad.newId}`);
        this.isNeadresnaPonuka = res.data;
      } catch (e) {
        console.error(e);
        this.isNeadresnaPonuka = false;
      } finally {
        this.neadresnaPonukaLoaded = true;
      }
    },
  },
  created() {
    //this.controlName = 'PripadyWizardSumar';
    this.setLoadingDialog({
      open: true,
      btext: 'Prebieha načítavanie...',
      utext: '',
    });
    this.getFormaPodnikania();
    this.getNeadresnaPonuka();
    this.getMenu();

    // protectedAxios
    // .post('sumar/schvalovanie-filip', {
    //       newId: "5d10e541-0195-4cba-b3aa-e45e53880c96",
    //       varianty: [
    //         {
    //           CisloPlz: "001000635000",
    //           IdVariantu: 2241643
    //         }
    //       ]
    //     })
  },
};
</script>
